<template>
  <div>
    <strong>{{ label }}</strong>
    <span v-if="disabled" v-html="value"/>
    <vue-easymde v-else v-model="value" ref="markdownEditor" :configs="configMDE" />
  </div>
</template>

<script>
import fieldMixin from '@/mixins/LeanField';
import VueEasymde from "vue-easymde";

export default {
  name: 'LeanMarkdown',
  mixins: [fieldMixin],
  components: {
    VueEasymde
  },
  data(){
    return {
      configMDE: {
        spellChecker: false,
        toolbar: [
          "bold",
          "italic",
          "strikethrough",
          "|",
          "heading-smaller",
          "heading-bigger",
          "|",
          "code",
          "quote",
          "|",
          "unordered-list",
          "ordered-list",
          "|",
          "clean-block",
          "|",
          "link",
          "image",
          "|",
          "table",
          "horizontal-rule",
          "|",
          "preview",
          "side-by-side",
          "|",
          "fullscreen",
          "guide"]
      }
    }
  }
};
</script>
<style>
@import "~easymde/dist/easymde.min.css";
</style>